import { render, staticRenderFns } from "./communicationList.vue?vue&type=template&id=6fe2e808&scoped=true&"
import script from "./communicationList.vue?vue&type=script&lang=js&"
export * from "./communicationList.vue?vue&type=script&lang=js&"
import style0 from "./communicationList.vue?vue&type=style&index=0&id=6fe2e808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe2e808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe2e808')) {
      api.createRecord('6fe2e808', component.options)
    } else {
      api.reload('6fe2e808', component.options)
    }
    module.hot.accept("./communicationList.vue?vue&type=template&id=6fe2e808&scoped=true&", function () {
      api.rerender('6fe2e808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/hdcommunication/communicationList.vue"
export default component.exports